import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWorkplaceComponent } from './simple-icons-workplace.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWorkplaceComponent ],
    exports:      [ SimpleIconsWorkplaceComponent ],
    bootstrap:    []
})
export class SimpleIconsWorkplaceModule {}
